import { entryPath } from "../lib/appEntryLink"
import React, { useCallback, useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { acquireTabSlot, MAX_CONCURRENT_TABS } from "../stream/tabSlots"

const RETRY_INTERVAL_MS = 2000

/**
 * Shown instead of the app when the user already has MAX_CONCURRENT_TABS tabs
 * open. Keeps checking in the background, so closing another tab lets this one
 * in without a manual refresh.
 */
const TooManyTabs = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [isChecking, setIsChecking] = useState(false)

  const checkForFreeSlot = useCallback(async () => {
    setIsChecking(true)
    const gotSlot = await acquireTabSlot()
    setIsChecking(false)

    if (gotSlot) {
      navigate(entryPath("/", window.location.search), { replace: true })
    }
  }, [navigate])

  useEffect(() => {
    window.analytics.track("TooManyTabsScreenShown", {
      maxTabs: MAX_CONCURRENT_TABS,
    })
  }, [])

  useEffect(() => {
    const interval = setInterval(checkForFreeSlot, RETRY_INTERVAL_MS)
    return () => clearInterval(interval)
  }, [checkForFreeSlot])

  return (
    <>
      <main className="grid place-items-center bg-slate-900 p-4">
        <img src="slickshift2.png" className="w-52" />
      </main>
      <main className="grid min-h-full place-items-center px-6 py-24 sm:py-4">
        <div className="text-center">
          <h1 className="mt-4 text-xl font-bold tracking-tight text-gray-900 sm:text-xl">
            {t("app.tooManyTabs.title")}
          </h1>
          <p className="mt-6 text-base leading-7 text-gray-600">
            {t("app.tooManyTabs.text", { max: MAX_CONCURRENT_TABS })}
          </p>
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <button
              onClick={checkForFreeSlot}
              disabled={isChecking}
              className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:opacity-60"
            >
              {isChecking
                ? t("app.tooManyTabs.checking")
                : t("app.actions.tryAgain")}
            </button>
          </div>
        </div>
      </main>
    </>
  )
}

export default TooManyTabs
